import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { MunicipiosAptosService } from '../shared/service/municipios-aptos.service';
import { AslibGridComponent, AslibTitleService } from '@aslib/components';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';
import { AlterarMuncicipiosAptos } from '../shared/model/municipios-aptos.model';
import { BaseConfig } from '../../shared/service/base-config.service';

type Filtro = {
  codMunicipio: number;
  dataVigencia: string;
};


type MunicipioCombo = {
  CodigoMunicipio: number | string;
  NomeMunicipio: string;
};


@Component({
  selector: 'sarf-consulta-municipios-aptos',
  templateUrl: './consulta-municipios-aptos.component.html'
})


export class ConsultaMunicipiosAptos  implements OnInit {
  @ViewChild('grid') grid: AslibGridComponent;

  MunicipiosFiltro: any[];
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  DataInicio: Date;
  showFile: ShowFile;
  exibirGrid:boolean = true;
  dadosMunicipiosAptos: any[]=[];
  filtro: Filtro;
  filtroVazio: Filtro = {
    codMunicipio: null,
    dataVigencia: null
  };
  dadosMunicipiosCombo: any[]=[];
  dadosMunicipiosAptosObj: AlterarMuncicipiosAptos ;
  usuarioLogado: any;
  
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  itemSelecionado: any;
  

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    private readonly municipiosAptosService: MunicipiosAptosService,
    private readonly _messages : Messages,
    private aslibTitleService: AslibTitleService,
    private cd: ChangeDetectorRef,
    private baseConfig: BaseConfig
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.dadosMunicipiosAptosObj = new AlterarMuncicipiosAptos();
    this.usuarioLogado = this.baseConfig.getUsuarioLogado();
  }

//metodos de ciclo de vida do componente
  ngOnInit() {
    this.filtro = { ...this.filtroVazio };
    this.dadosOnInitFormulario(this.modalMensagem);
  }


ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Municípios Aptos";
    this.aslibTitleService.SubText = "Consultar"
    this.cd.detectChanges(); 
  });
}

onClose(fechas:boolean){
    this.aslibModal.close(fechas);
  }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  //metodos de negócio
formConsultaRoyalties = new FormGroup({
    dataReferenciaMunicipio: new FormControl('', Validators.required)
  });


/** Converte 'MM/YYYY' para [primeiroDiaDoMes, ultimoDiaDoMes] (Date locais, 00:00) */
monthRangeFromMmYyyy(mmyyyy: string): { start: Date; end: Date } {
  const mmYyyyRegex = /^(0[1-9]|1[0-2])\/(\d{4})$/;
  const m = mmYyyyRegex.exec(mmyyyy);
  if (!m) {
    this.exibirError(`Formato inválido. Use 'MM/YYYY'. Valor recebido: '${mmyyyy}'`);
  }
  const month = Number(m[1]);      // 01..12
  const year  = Number(m[2]);      // 4 dígitos

  // Início do mês (local)
  const start = new Date(year, month - 1, 1); // 00:00 local
  // Fim do mês (local): dia 0 do mês seguinte -> último dia do mês atual
  const end = new Date(year, month, 0);       // 00:00 local

  return { start, end };
}

/** Converte string 'YYYY-MM-DD' ou Date para Date local no início do dia */
toStartOfDayLocal(d: string | Date): Date {
  if (d instanceof Date) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  // Trata 'YYYY-MM-DD' como data local (evita UTC afetar)
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const [y, m, day] = d.split('-').map(Number);
    return new Date(y, m - 1, day);
  }
  // Fallback para outros formatos
  const parsed = new Date(d);
  if (isNaN(parsed.getTime())) {
    throw new Error(`Data inválida: '${d}'`);
  }
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

 /**
     * filtrar
     * Função para filtrar registros
       */
    filtrar(grid: AslibGridComponent) {
      this.MunicipiosFiltro = this.dadosMunicipiosAptos;

      if (this.filtro.codMunicipio !== null && this.filtro.codMunicipio !== 0) {
        this.MunicipiosFiltro = this.MunicipiosFiltro.filter(t => {
          if(t.CodigoMunicipio == this.filtro.codMunicipio){
            return t;}});
      }

      if (this.filtro.dataVigencia != null && this.filtro.dataVigencia !== '') {
        const { start: mesInicio, end: mesFim } = this.monthRangeFromMmYyyy(this.filtro.dataVigencia);
        const mesInicioTime = mesInicio.getTime();
        const mesFimTime = mesFim.getTime();

        this.MunicipiosFiltro = this.MunicipiosFiltro.filter(t => {
          const inicio = this.toStartOfDayLocal(t.DataInicioVigencia);
          const fim    = t.DataFimVigencia ? this.toStartOfDayLocal(t.DataFimVigencia) : null;

          const iniTime = inicio.getTime();
          const fimTime = fim ? fim.getTime() : Number.POSITIVE_INFINITY;

          // Interseção inclusiva entre [ini, fim] e [mesInicio, mesFim]
          return iniTime <= mesFimTime && fimTime >= mesInicioTime;
        });

      }

      grid.dataset = this.MunicipiosFiltro;
      if(this.MunicipiosFiltro.length==0){
        this.exibirError('Não existem registros para os filtros informados!');
      }
    }

irPraAdicionar(): void {
    this.router.navigate(['/royalts/sarf-cadastro-municipios-aptos']);
  }
   setaDados(municipioApto: any) {
    this.dadosMunicipiosAptosObj.SequencialMunicipioAptoRecebimentoRoyalty = municipioApto.SequencialMunicipioAptoRecebimentoRoyalty;
    this.dadosMunicipiosAptosObj.SiglaUnidadeFederacao = municipioApto.SiglaUnidadeFederacao;
    this.dadosMunicipiosAptosObj.CodigoMunicipio = municipioApto.CodigoMunicipio;
    this.dadosMunicipiosAptosObj.DataInicioVigencia = municipioApto.DataInicioVigencia;
    this.dadosMunicipiosAptosObj.DataFimVigencia = municipioApto.DataFimVigencia;
    this.dadosMunicipiosAptosObj.DescricaoObservacao = municipioApto.DescricaoObservacao;
    this.dadosMunicipiosAptosObj.LoginUsuario = this.usuarioLogado.Login;
  }

public limparConsulta(){
      this.formConsultaRoyalties.reset();
      this.filtro = { ...this.filtroVazio };
      this.MunicipiosFiltro = [];
       this.dadosOnInitFormulario(this.modalMensagem);
 }

exibirSucesso(mensagem:string){      
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'info'
      }
    );
  } 

  exibirError(mensagem:string){            
    this._aslibLoadingService.complete();
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'Info',
        windowClass: 'modalAlterado'
      }
    );
  }


//Metodos de interação com o serviço
dadosOnInitFormulario(modal: AslibModalComponent){
    this.observerOnIniftFormulario = this.municipiosAptosService.dadosOnInitFormulario().subscribe(
      retornoRequest => {
          const lista = [...retornoRequest.ListaMuncicipiosAptosRoyalty] as MunicipioCombo[];
          
          // Crie pares tipados como tupla [string, MunicipioCombo]
          const pares: [string, MunicipioCombo][] = lista.map(
            m => [String(m.CodigoMunicipio), m] as [string, MunicipioCombo]
          );

          // Informe os genéricos no Map
          const mapa = new Map<string, MunicipioCombo>(pares);

          const semDuplicados = Array.from(mapa.values());
          this.dadosMunicipiosCombo = semDuplicados;

         this.dadosMunicipiosAptos = [...retornoRequest.ListaMuncicipiosAptosRoyalty];

        if(retornoRequest.objetoMensagem &&  
          retornoRequest.objetoMensagem.Mensagem !== null &&  
          retornoRequest.objetoMensagem.Mensagem !== '') {
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }
 

editar(conteudo: any, item: any){
  this.itemSelecionado = item;
  const options: IAslibModalOptions = {
      title: 'Detalhes do Município Apto',
      backdrop: 'static',
      footerVisible: false,
      size: 'lg',
      content: conteudo,
      okText:'Salvar',
      cancelarText:'Cancelar',
      okVisible:false,
      cancelarVisible:false
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
}

 onConfirmPropagar(valorDistribuir: any){
    this.setaDados(valorDistribuir);  

    this._aslibLoadingService.start();
      this.subscription =  this.municipiosAptosService
        .alterarrMunicipiosAptos(this.dadosMunicipiosAptosObj)
        .subscribe(          
          data => {
            if(data.Data){
              this.exibirSucesso(data.Message);
              this.aslibModal.close(true);
              this.dadosOnInitFormulario(this.modalMensagem);
            }else{
              this.exibirError(data.Message);
            }        
          },
          (error: any) => {
            debugger
            this.exibirError(error.ExceptionMessage || error.Mensagem);
            this._aslibLoadingService.complete();
          },
          () => {
            this.unSubscribe(); 
          }
        );
    
  }

excluir(modal:AslibModalService, item): void {
const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Confirma a exclusão do registro atual?`,
      okText: 'Sim',
      cancelarText: 'Não',
      content: null,
      cancelarVisible: true
    };
    modal.open(options).result.then(
      () => {
           this._aslibLoadingService.start();
      this.subscription =  this.municipiosAptosService
        .deletarMunicipiosAptos(item.SequencialMunicipioAptoRecebimentoRoyalty)
        .subscribe(          
          data => {
            if(data.Data){
              this.exibirSucesso(data.Message);
              this.dadosOnInitFormulario(this.modalMensagem);
            }else{
              this.exibirError(data.Message);
            }        
          },
          (error: any) => {
            this.exibirError(error.Mensagem);
            this._aslibLoadingService.complete();
          },
          () => {
            this.unSubscribe(); 
          }
        );
      },
      () => {}
    );
}

gerarRelatorio() {
const DadosExcel = 
  (this.MunicipiosFiltro && this.MunicipiosFiltro.length > 0)
    ? this.MunicipiosFiltro
    : this.dadosMunicipiosAptos;


    this._aslibLoadingService.start();
    this.subscription = this.municipiosAptosService
      .gerarRelatoriodeMunicipiosAptos(DadosExcel).subscribe(
        data => {
          this.showFile.Windows(data,ExportTypes.Excel_xls,'MunicipiosAptosRoyalty');
        },
        (error: any) => {
          this._aslibLoadingService.complete();
          new AslibModalComponent(this.aslibModalService).open({
            title: 'ERRO',
            text: this._messages.MN0011,
            type: 'erro'
          });
        },
        () => {
          this.unSubscribe();
        }
      );
    }


}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/consulta-municipios-aptos.component.ts